import React from 'react';
import FooterView from './FooterView';
import useFooterLogic from './FooterLogic';

/**
 * Footer component that connects logic and view
 */
const Footer = () => {
  const { footerSections, socialLinks, navigateTo } = useFooterLogic();
  
  return (
    <FooterView 
      footerSections={footerSections}
      socialLinks={socialLinks}
      navigateTo={navigateTo}
    />
  );
};

export default Footer; 